import {ReportName} from 'common/report/constants';
import {FlowsResponse} from 'common/report/funnels/models/api-types';

import {QueryManager} from '../report-manager/query';
import {BaseQueryErrorType} from '../types';
import {ChartType, FlowsBookmark} from './models/types';

export class FlowsQueryManager extends QueryManager<FlowsBookmark, FlowsResponse, BaseQueryErrorType> {
  public reportName = ReportName.Flows;
  public endpoint = `arb_funnels`;

  public getExtraPostParams(bookmarkParams: FlowsBookmark) {
    return {query_type: bookmarkParams.chartType === ChartType.Paths ? `flows_top_paths` : `flows_sankey`};
  }

  public transformBookmarkParams(bookmarkParams: FlowsBookmark) {
    return bookmarkParams;
  }
}
